export default __webpack_public_path__ + "static/media/yellow-star.ee03f534.svg";